"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestQueueSummarySchema = exports.requestQueueRowSchema = exports.REQUEST_KINDS = exports.overtimeRequestSummarySchema = exports.leaveRequestSummarySchema = void 0;
const zod_1 = require("zod");
const leave_request_1 = require("./leave-request");
const overtime_1 = require("./overtime");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 31 Oct 2026 · The request lists, one page at a time — RULE 8 additions.   │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * `/leave-requests` and `/overtime` returned every request the reader could see, and the screens
 * filtered, sorted and paged them in memory — 3,276 leave requests on UAT and growing every year.
 * Both lists page on the server now, and these are the shapes that came with it: the counts and
 * filter options a page cannot know, and the approvers' queue, which interleaves the two kinds.
 */
const byStatusSchema = zod_1.z.object({
    pending: zod_1.z.number().int().nonnegative(),
    approved: zod_1.z.number().int().nonnegative(),
    rejected: zod_1.z.number().int().nonnegative(),
    revoked: zod_1.z.number().int().nonnegative(),
});
/**
 * `GET /leave-requests/summary` — the status tabs' counts, every filter but the status applied, so
 * a tab's number is what choosing it would list; and the frame years the year filter offers.
 */
exports.leaveRequestSummarySchema = zod_1.z.object({
    total: zod_1.z.number().int().nonnegative(),
    byStatus: byStatusSchema,
    /** ⚠️ Newest first, and counted without the year filter — choosing one must not hide the rest. */
    years: zod_1.z.array(zod_1.z.number().int()),
});
/**
 * `GET /overtime/summary` — the status tabs' counts and the type filter's options over the list's
 * filters, and the three figures over Kérelmeim's *Túlóra* tab over the reader's whole list.
 */
exports.overtimeRequestSummarySchema = zod_1.z.object({
    total: zod_1.z.number().int().nonnegative(),
    byStatus: byStatusSchema,
    /** The types the listed claims carry — an undecided claim has none to filter by. */
    types: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string() })),
    /**
     * ⚠️ Hours, as strings — `numeric` crosses the driver as one. A rejected or revoked claim is
     * overtime nobody owes, so the month leaves them out. *This year* and *this month* are the
     * server's calendar.
     */
    hours: zod_1.z.object({
        approvedYear: zod_1.z.string(),
        pending: zod_1.z.string(),
        thisMonth: zod_1.z.string(),
    }),
});
/** The queue's two kinds — its kind filter's values. */
exports.REQUEST_KINDS = ['leave', 'overtime'];
/**
 * `GET /requests` — one row of the approvers' queue, which lists leave requests and overtime claims
 * in one sorted list. ⚠️ **Each row is the kind's own wire shape**, not a union of their fields: the
 * queue draws the same cells the two personal tabs draw.
 */
exports.requestQueueRowSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('leave'), leave: leave_request_1.leaveRequestSchema }),
    zod_1.z.object({ kind: zod_1.z.literal('overtime'), overtime: overtime_1.overtimeRequestSchema }),
]);
/** `GET /requests/summary` — the queue's status tabs, every filter but the status applied. */
exports.requestQueueSummarySchema = zod_1.z.object({
    total: zod_1.z.number().int().nonnegative(),
    byStatus: byStatusSchema,
});
//# sourceMappingURL=request-list.js.map